import { create } from 'zustand';

type OSSignupModalStep = 'local-purchase' | 'local-complete';

interface OSSignupModalState {
  isOpen: boolean;
  initialStep: OSSignupModalStep;
  sessionId: string | null;
  open: (step?: OSSignupModalStep) => void;
  close: () => void;
  setSessionId: (id: string) => void;
}

export const useOSSignupModalStore = create<OSSignupModalState>((set) => ({
  isOpen: false,
  initialStep: 'local-purchase',
  sessionId: null,
  open: (step = 'local-purchase') => set({ isOpen: true, initialStep: step, sessionId: null }),
  close: () => set({ isOpen: false, sessionId: null }),
  setSessionId: (id) => set({ sessionId: id }),
}));
